import React from 'react'
import { string, object, oneOfType } from 'prop-types'
import richContentRenderers from './renderers'
import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { useStore } from '@bluheadless/ui-logic/src/providers/store'
import { mediaUrl, assetUrl, sameOriginMediaUrl } from '@bluheadless/ui-logic/src/assets'

const useReplaceGlobalVars = (content) => {
	const { locale } = useConfig()
	const { code: storeCode, groupName, groupId, baseUrl, uri } = useStore()

	let _content = content ?? ''

	// Replace language
	_content = _content.replaceAll('{{bh-language}}', locale.split('-')[0])
	// Replace locale
	_content = _content.replaceAll('{{bh-locale}}', locale)
	// Replace store code
	_content = _content.replaceAll('{{bh-storeCode}}', storeCode)
	// Replace group name
	_content = _content.replaceAll('{{bh-groupName}}', groupName)
	// Replace group id
	_content = _content.replaceAll('{{bh-groupId}}', groupId)
	// Replace base url code
	_content = _content.replaceAll('{{bh-baseUrl}}', baseUrl)
	// Replace uri
	_content = _content.replaceAll('{{bh-uri}}', uri)
	// Replace media url
	_content = _content.replaceAll('{{bh-mediaUrl}}', mediaUrl(''))
	// Replace same origin media url
	_content = _content.replaceAll('{{bh-sameOriginMediaUrl}}', sameOriginMediaUrl(''))
	// Replace asset url
	_content = _content.replaceAll('{{bh-assetUrl}}', assetUrl(''))

	return _content
}

const RichContent = ({ content: _content, ...props }) => {
	const content = useReplaceGlobalVars(_content)

	if (!content) return null

	for (const Renderer of richContentRenderers) {
		const { Component, canRender } = Renderer
		if (canRender(content)) {
			return <Component content={content} {...props} />
		}
	}
	// If no renderer returned a value
	if (process.env.NODE_ENV === 'development') {
		console.warn(
			`None of the following rich content renderers returned anything for the provided content.`,
			richContentRenderers.map((r) => `<${r.name}>`),
			content
		)
	}
	return null
}

const RichContentWrapper = (props) => {
	return <RichContent {...props} RichContentComponent={RichContent} />
}

RichContent.propTypes = {
	content: oneOfType([string, object]),
}

// export default RichContent
export default RichContentWrapper
